import { Media, ProgressBar } from 'react-bootstrap'
import Link from 'next/link'
import { ModuleWrapper } from '@components/Block'

function ModuleCard(data) {
    return (
        <ModuleWrapper>
            <Link href="/learn-and-earn/[content]" as={`/learn-and-earn/${data.id}`} passHref>
                <a target="_blank" className="text-reset text-decoration-none h7">
                    <Media className="ml-sm-5 flex-sm-row flex-column">
                        <div className="mr-sm-4 mb-sm-0 mb-3  thumbnail">
                            <img
                            className="img-fluid"
                            src={data.imgsrc}
                            alt="Module one"
                            />
                            <ProgressBar now={40}/>
                        </div>
                        <Media.Body className="h10">
                            <h6><strong>{data.title}</strong></h6>
                            <p >{data.subtitle}</p>
                            <p>{data.duration} mins</p>
                        </Media.Body>
                    </Media>
                </a>
            </Link>
            <style jsx global>{`

                .thumbnail{
                    width:230px;
                }

                @media screen and (min-width:768px){
                    .media-body{
                        width: 454px;
                    }
                    .module-heading{
                        max-width: 515px;
                    }
                }
            `}</style>
        </ModuleWrapper>
    );
  }
export default ModuleCard